import React from "react";
import { useApp } from "@/context/AppContext";
import { ccyMeta } from "@/lib/fx";

/** Segmented control on the dashboard: the client's home currency, USD and the euro. */
export const CurrencyToggle = () => {
  const { displayCcy, setDisplayCcy, homeCcy } = useApp();
  const codes = [...new Set([homeCcy, "USD", "EUR"])].slice(0, 3);
  return (
    <div className="inline-flex items-center rounded-full border border-border/70 bg-secondary/60 p-0.5"
      data-testid="dashboard-currency-toggle">
      {codes.map((code) => {
        const c = ccyMeta(code);
        return (
          <button key={code} onClick={() => setDisplayCcy(code)} title={c.label}
            data-testid={`currency-option-${code}`}
            className={`px-3 h-8 rounded-full text-xs font-semibold transition-colors ${
              displayCcy === code
                ? "bg-card text-foreground shadow-premium"
                : "text-muted-foreground hover:text-foreground"
            }`}>
            {c.symbol ? `${c.symbol} ` : ""}{c.code}
          </button>
        );
      })}
    </div>
  );
};
